<!-- DeleteCouponReservationForm.vue -->
 <!-- DeleteCouponReservationForm.vue -->
<script setup>
import { computed } from "vue";
import { useCouponReservationStore } from "@/stores/useCouponReservationStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const props = defineProps({
  reservation: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useCouponReservationStore();

const reservationId = computed(() => {
  return (
    props.reservation?.couponReservationId ||
    props.reservation?.CouponReservationId ||
    null
  );
});

const reservationLabel = computed(() => {
  const r = props.reservation;
  if (!r) return "";

  const code = r.couponCode || r.CouponCode || `#${r.couponId ?? r.CouponId ?? ""}`;
  const user = r.userName || r.UserName || `#${r.userId ?? r.UserId ?? ""}`;

  return `reserva do cupom "${code}" para ${user}`;
});

const messageTitle = computed(() => {
  const label = reservationLabel.value;
  if (!label) return "Tem certeza que deseja apagar esta reserva?";
  return `Tem certeza que deseja apagar a ${label}?`;
});

function buildDeleteError(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir a reserva."
  );
}

async function onConfirmDelete() {
  try {
    if (!reservationId.value) {
      throw new Error("ID da reserva não encontrado para exclusão.");
    }

    await store.deleteCouponReservationById(reservationId.value);

    emit("notify", {
      type: "success",
      message: "Reserva apagada com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Reserva de Cupom"
    :messageTitle="messageTitle"
    messageSubtitle="Se a reserva já foi consumida, ela faz parte do histórico financeiro da assinatura — ao apagá-la, esse rastro será perdido. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>